import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: GreenTurtwig
 * id CF313E88-0D2F-49B9-B2BC-6651ACEAA677
 * name numeric-9-plus
 * version: 4.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/numeric-9-plus.svg
 * tags
 * - Alpha / Numeric 
 */
export const Numeric9PlusIcon = createSvgIcon(<><path d="M19 11H17V9H15V11H13V13H15V15H17V13H19V11M10 7H8C6.9 7 6 7.9 6 9V11C6 12.11 6.9 13 8 13H10V15H6V17H10C11.11 17 12 16.11 12 15V9C12 7.89 11.1 7 10 7M10 11H8V9H10V11Z" /></>, 'Numeric9PlusIcon');
export default Numeric9PlusIcon